module.exports = __webpack_public_path__ + "img/Asset 2@2x.fda92f9c.png";